<template>
	<span
		class="flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded-full"
		:class="paletteClasses"
	>
		<AppIcon v-if="icon" :name="icon" class="text-base leading-none" />
		<slot />
	</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
	palette?: string;
	icon?: string;
}

const props = withDefaults(defineProps<Props>(), {
	palette: "zinc",
});

const paletteClasses = computed(() => ({
	"bg-zinc-100 text-zinc-600": props.palette == "zinc",
	"bg-green-100 text-green-600": props.palette == "green",
	"bg-amber-100 text-amber-600": props.palette == "amber",
	"bg-red-100 text-red-600": props.palette == "red",
}));
</script>
